const SELECTED_PROJECT_ID_KEY = "selectedProjectId";

/**
 * Save selected project ID to sessionStorage
 * @param projectId - The project ID to store (as a number)
 */
export const saveSelectedProjectId = (projectId: string | number): void => {
  try {
    const projectIdNum = typeof projectId === "string" ? Number(projectId) : projectId;
    sessionStorage.setItem(SELECTED_PROJECT_ID_KEY, String(projectIdNum));
  } catch (error) {
    console.error("Failed to save selected project ID to sessionStorage:", error);
  }
};

/**
 * Load selected project ID from sessionStorage
 * @returns The project ID as a number, or null if not found or invalid
 */
export const loadSelectedProjectId = (): number | null => {
  try {
    const stored = sessionStorage.getItem(SELECTED_PROJECT_ID_KEY);
    if (!stored) {
      return null;
    }
    
    const projectId = Number(stored);
    
    // Validate it's a valid number
    if (Number.isNaN(projectId)) {
      return null;
    }
    
    return projectId;
  } catch (error) {
    console.error("Failed to load selected project ID from sessionStorage:", error);
    return null;
  }
};

/**
 * Clear selected project ID from sessionStorage
 */
export const clearSelectedProjectId = (): void => {
  try {
    sessionStorage.removeItem(SELECTED_PROJECT_ID_KEY);
  } catch (error) {
    console.error("Failed to clear selected project ID from sessionStorage:", error);
  }
};

/**
 * Check if sessionStorage has a selected project ID
 */
export const hasSelectedProjectId = (): boolean => {
  try {
    return sessionStorage.getItem(SELECTED_PROJECT_ID_KEY) !== null;
  } catch (error) {
    console.error("Failed to check sessionStorage:", error);
    return false;
  }
};
